var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('span',[_vm._v("Datum:")]),_vm._v(" "),_c('date-picker',{attrs:{"date":_vm.startTime,"option":_vm.option,"limit":_vm.limit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }